import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
import { logOutAdmin, logOutUser } from "@global-state/global/slice";

const role: string = process.env.NODE_ENV === "production" ? window.location.origin.includes("panel") ? "admin" : "user" : window.location.pathname.includes("admin") ? "admin" : "user"

function baseQuery() {
    return fetchBaseQuery({
        baseUrl: "https://api.rocket-proxy.io/" + (role === "admin" ? "admin" : "customer"),
        credentials: "include"
    });
}

const baseQueryWithReauth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    let result = await baseQuery()(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        const refreshResult = await baseQuery()(
            {
                url: "/auth/refresh_tokens",
                method: "POST",
            },
            api,
            extraOptions,
        );

        if (refreshResult.data) {
            result = await baseQuery()(args, api, extraOptions);
        } else {
            if (role === "admin") {
                api.dispatch(logOutAdmin());
            } else if (role === "user") {
                api.dispatch(logOutUser());
            }
        }
    }
    return result;
};

export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["ProxyUser", "ProxyAdmin", "PromoCodeAdmin", "HistoryUser", "CostsAdmin", "UserAdmin", "ProxyUserAdmin", "PersonalUserTariffsAdmin", "PurchaseHistoryAdmin"],
    endpoints: () => ({}),
});

export const logApi = createApi({
    reducerPath: "logApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://api.rocket-proxy.io/" + (role === "admin" ? "admin" : "customer"),
        credentials: "include"
    }),
    endpoints: () => ({}),
});
